import Downshift from "downshift";
import classNames from "classnames";
import React from "react";
import { findDietTagImg } from "../helpers/singleOfferHelpers";
import faChevronDown from "../img/icons/downChevron.svg";
import Icon from "./Icon";

export const Select = ({
  dietUrl,
  disabled,
  items,
  label,
  placeholder,
  selectedItem,
  selectedItemKey,
  selectItem,
  selectLink,
  containerClass,
  id,
  smallHeight,
  path,
}) => {
  return (
    <>
      <Downshift
        id={id}
        itemToString={(item) => (item ? item[selectedItemKey] : "")}
        onChange={(item) => selectItem(item)}
      >
        {({ getItemProps, getToggleButtonProps, isOpen }) => (
          <div className={classNames("select", containerClass)}>
            {label && (
              <p className="label-m color-gray-500 spacer-bottom-8">{label}</p>
            )}
            <div
              className={classNames("select__button label-m", {
                "select__button--link": selectLink,
                "select__button--small": smallHeight,
              })}
              {...getToggleButtonProps()}
            >
              <span
                className={classNames({
                  "select__selectedItem--link": selectLink,
                  select__selectedItem: !dietUrl,
                  select__selectedItemWithImg: dietUrl,
                })}
              >
                {(() => {
                  if (selectedItem && Object.keys(selectedItem).length > 0) {
                    if (dietUrl) {
                      return (
                        <span className="display-flex align-items-center">
                          <img
                            alt={selectedItem?.dietName}
                            src={
                              selectedItem?.dietImageUrl
                                ? selectedItem?.dietImageUrl
                                : findDietTagImg(selectedItem?.dietTag)
                            }
                          />
                          {selectedItem[selectedItemKey]}
                        </span>
                      );
                    }
                    return selectedItem[selectedItemKey];
                  }
                  if (placeholder) {
                    return placeholder;
                  }
                  return "Wybierz..";
                })()}
              </span>
              {!disabled && (
                <span
                  className={classNames({
                    "select__selectedItem-icon-select-link":
                      selectLink || selectedItem,
                  })}
                >
                  <Icon
                    classes="spacer-right-8 width-14"
                    url={(path && path + faChevronDown) || faChevronDown}
                  />
                </span>
              )}
            </div>
            <div className="select__itemsWrapper">
              {isOpen && !disabled ? (
                <div className="select__downshiftDropdown">
                  {items.map((item, index) =>
                    dietUrl ? (
                      <div
                        className="select__dropdownItemWithUrl label-m"
                        key={index}
                        {...getItemProps({ key: index, index, item })}
                      >
                        {dietUrl && (
                          <img
                            alt={item?.dietName}
                            src={
                              item?.dietImageUrl
                                ? item?.dietImageUrl
                                : findDietTagImg(item?.dietTag)
                            }
                          />
                        )}
                        {item[selectedItemKey]}
                      </div>
                    ) : (
                      <div
                        className="select__dropdownItem label-m"
                        key={index}
                        {...getItemProps({ key: index, index, item })}
                      >
                        {item[selectedItemKey]}
                      </div>
                    )
                  )}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </Downshift>
    </>
  );
};
